import { completeTask, type DashboardTask } from '../../api/dashboard';
import { updateSuggestion } from '../../data/suggestions';

export async function completeHomeTask(task: DashboardTask): Promise<void> {
  if (String(task.metadata?.type || '').toLowerCase() === 'suggestion_submitted') {
    const suggestionId = String(task.metadata?.suggestionId || '').trim();
    if (!suggestionId) throw new Error('Open the suggestion to update its status.');
    const { error } = await updateSuggestion(suggestionId, { status: 'resolved' });
    if (error) throw error;
    return;
  }
  await completeTask(task.id);
}
